import path from 'node:path'
export function getHostProjectFilesToRestore(cwd: string): string[] {
  const hostRelativePaths = [
    'app/layout.tsx',
    'app/layout.ts',
    'app/layout.jsx',
    'app/layout.js',
    'src/app/layout.tsx',
    'src/app/layout.ts',
    'src/app/layout.jsx',
    'src/app/layout.js',
    'app/globals.css',
    'src/app/globals.css'
  ]

  return hostRelativePaths.map((relativePath) => path.join(cwd, relativePath))
}
